<div class="modal-body">
    <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
    <div class="step-detail-title">Test information</div>
    <div class="container-fluid" *cmLet="step.test_instance as testInstance">
        <div class="row" *ngIf="(getVisible | thunk: fields:'exam_name') && testInstance.exam_name">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Exam name</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.exam_name }}</div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'compliance_status_text')">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Test status</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.compliance_status_text }}</div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'scheduled_date') && testInstance.scheduled_date">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Test scheduled date</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.scheduled_date | dateFormat }}</div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'rescheduled_date') && testInstance.rescheduled_date">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Test rescheduled date</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.rescheduled_date | dateFormat }}</div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'score')">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Score</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">
                {{ testInstance.score }} / {{ testInstance.score_max }} (min={{ testInstance.score_min }})
            </div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'cancelled_by') && testInstance.cancelled_by">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Cancelled by</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.cancelled_by }}</div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'testing_center') && testInstance.testing_center">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Testing center</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.testing_center }}</div>
        </div>
        <div class="row" *ngIf="(getVisible | thunk: fields:'testing_center_city') && testInstance.testing_center_city">
            <div class="col-lg-5 col-md-5 col-sm-5 px-0">Testing center city</div>
            <div class="col-lg-7 col-md-7 col-sm-7 px-0">{{ testInstance.testing_center_city }}</div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <a *ngIf="step.psi_site_link" class="btn btn-primary" [href]="step.psi_site_link" target="_blank">
        Login to PSI system
    </a>
    <button type="button" class="btn btn-primary" (click)="dismissModal()">CLOSE</button>
</div>
